import React from 'react';
import { CATEGORIES, CATEGORY_IDS, LIBRARY } from './shapeLibrary';
import { NoResultsIcon, ShapeIcon } from './sidebarIcons';
import './shapeBrowser.css';

// A shape the user can drag onto the mind map.
export const ShapeTile = ({ shape, dragProps, className = 'shape-tile' }) => (
    <button type="button" className={className} title={shape.name} aria-label={shape.name} {...dragProps(shape)}>
        <ShapeIcon shape={shape} />
    </button>
);

const RecentShapes = ({ recent, dragProps }) => (
    <section className="shape-section shape-section--recent">
        <h3 className="shape-section-title">Recently used</h3>
        <div className="shape-grid">
            {recent.map((shape) => (
                <ShapeTile key={shape.name} shape={shape} dragProps={dragProps} className="shape-tile shape-tile--recent" />
            ))}
        </div>
    </section>
);

const CategoryGroup = ({ id, dragProps }) => {
    const shapes = LIBRARY.filter((shape) => shape.category === id);
    return (
        <section className="shape-section">
            <div className="shape-section-header">
                <h3 className="shape-section-title">
                    <span className="category-dot" style={{ background: CATEGORIES[id].stroke }} />
                    {CATEGORIES[id].label}
                </h3>
                <span
                    className="shape-section-count"
                    style={{ background: CATEGORIES[id].fill, color: CATEGORIES[id].stroke }}
                    aria-label={`${shapes.length} shapes`}
                >
                    {shapes.length}
                </span>
            </div>
            <div className="shape-grid">
                {shapes.map((shape) => <ShapeTile key={shape.name} shape={shape} dragProps={dragProps} />)}
            </div>
        </section>
    );
};

const SearchResults = ({ results, dragProps }) => (
    <div className="shape-results">
        <span className="shape-results-count">{results.length === 1 ? '1 shape' : `${results.length} shapes`}</span>
        {results.map((shape) => (
            <button key={shape.name} type="button" className="shape-result" title={shape.name} {...dragProps(shape)}>
                <span className="shape-result-icon"><ShapeIcon shape={shape} size={26} /></span>
                <span className="shape-result-text">
                    <span className="shape-result-name">{shape.name}</span>
                    <span className="shape-result-category">{CATEGORIES[shape.category].label}</span>
                </span>
            </button>
        ))}
    </div>
);

const NoResults = ({ query, onReset }) => (
    <div className="shape-empty">
        <span className="shape-empty-icon"><NoResultsIcon /></span>
        <span className="shape-empty-title">No shapes match “{query}”</span>
        <span className="shape-empty-hint">Try a shorter word, like “arrow” or “box”, or search in all categories.</span>
        <button type="button" className="shape-empty-reset" onClick={onReset}>Clear search</button>
    </div>
);

// The scrolling body: recent shapes and categories while browsing, a result list while searching.
const ShapeBrowser = ({ query, category, results, recent, dragProps, onReset }) => {
    if (query.trim()) {
        return results.length > 0
            ? <SearchResults results={results} dragProps={dragProps} />
            : <NoResults query={query.trim()} onReset={onReset} />;
    }
    const groups = CATEGORY_IDS.filter((id) => category === 'all' || id === category);
    return (
        <>
            {category === 'all' && recent.length > 0 && <RecentShapes recent={recent} dragProps={dragProps} />}
            {groups.map((id) => <CategoryGroup key={id} id={id} dragProps={dragProps} />)}
        </>
    );
};

export default ShapeBrowser;
